import { render } from "./popHeader.vue?vue&type=template&id=0cf227e4&scoped=true"
import script from "./popHeader.vue?vue&type=script&lang=js"
export * from "./popHeader.vue?vue&type=script&lang=js"

import "./popHeader.vue?vue&type=style&index=0&id=0cf227e4&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf227e4"]])

export default __exports__